const initialState = {
	comments: [],
	commentCount: 0,
	commentCurrent: 1,
	hideCom: false
}

const com = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_COMMENTS':
			return {
				...state,
				comments: action.comments,
				commentCount: action.commentCount,
				commentCurrent: action.commentCurrent
			}
		case 'TOGGLE_COM':
			return {
				...state,
				hideCom: action.hideCom
			}

		case 'RESET_COMM_STATE':
			return {
				...initialState
			}

		default:
			return { ...state }
	}
}

export default com
